import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { join } from 'lodash';
import routeList from '../../routes/routeList';

const Book = ({ title, author, cover, slug }) => {
  const coverURL = cover !== 'false' ? cover : '/placeholders/cover.png';
  return (
    <Link to={`${routeList.reading}/${slug}`}>
      <div className="book-wrapper">
        <div className="book-cover-wrapper">
          <div className="cover-aspect-ratio-box">
            <div className="cover-aspect-ratio-box-inside">
              <img src={coverURL} alt={title} className="book-cover" />
            </div>
          </div>
        </div>
        <div className="book-details">
          <p className="text-center subtitle-2">{title}</p>
          <p className="author-name">{join(author.map(el => el.post_title), ', ')}</p>
        </div>
      </div>
    </Link>
  );
};

Book.propTypes = {
  title: PropTypes.string,
  author: PropTypes.array,
  cover: PropTypes.string,
  slug: PropTypes.string
};

export default Book;
